import { reducer } from "./payments";

export { actions } from "./payments";
export { fetchPaymentsAction } from "./slices/fetch-payments";

export default reducer;
